/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreditCardPaymentResultGridViewModelPaginatedResponse } from "../types/CreditCardPaymentResultGridViewModelPaginatedResponse.ts";
import { creditCardPaymentResultGridViewModelSchema } from "./creditCardPaymentResultGridViewModelSchema.ts";

export const creditCardPaymentResultGridViewModelPaginatedResponseSchema =
  z.object({
    data: z
      .array(z.lazy(() => creditCardPaymentResultGridViewModelSchema))
      .nullish(),
    currentPage: z.optional(z.number().int()),
    totalPages: z.optional(z.number().int()),
    totalCount: z.optional(z.number().int()),
  }) as unknown as ToZod<CreditCardPaymentResultGridViewModelPaginatedResponse>;
